import { useState } from 'react';

import CookieBanner from '@skyscanner-internal/global-components/cookie-banner';
import ConsentBanner from '@skyscanner-internal/global-components/unstable__consent-banner';
import { GLOBAL } from 'saddlebag-browser';
import { logError, logOperationalEvent, logWarn } from 'saddlebag-logger';

import { logWarnWrapper } from '../../services/logWrapper';

import type { Logger } from '@skyscanner-internal/global-components/types/utils';

export const GlobalCookieBanner = () => {
  const [isOpen, setIsOpen] = useState(true);
  const $window = GLOBAL.getWindow();
  const { cookieBannerProps } = $window.__internal;

  if (!cookieBannerProps) {
    logWarnWrapper({
      message: 'cookieBannerProps is not defined',
      component: 'GlobalCookieBanner',
    });
    return null;
  }

  const logger: Logger = {
    logError,
    logWarn,
    logOperationalEvent,
  };

  const {
    enableKetchCMP = false,
    isProductionEnv,
    market,
    showCookieBanner,
    strings,
    totalNumberOfVendors,
    transparencyConsentFrameworkConfigVersionNumber,
  } = cookieBannerProps;

  const handleOnPolicyAcceptClick = () => {
    setIsOpen(false);
  };

  if (isOpen && enableKetchCMP) {
    return (
      <ConsentBanner
        isProductionEnv={isProductionEnv}
        logger={logger}
        onPolicyAcceptClick={handleOnPolicyAcceptClick}
        strings={strings}
      />
    );
  }

  return (
    <>
      {showCookieBanner && isOpen && (
        <CookieBanner
          isProductionEnv={isProductionEnv}
          logger={logger}
          market={market}
          onPolicyAcceptClick={handleOnPolicyAcceptClick}
          strings={strings}
          totalNumberOfVendors={totalNumberOfVendors}
          transparencyConsentFrameworkConfigVersionNumber={
            transparencyConsentFrameworkConfigVersionNumber
          }
        />
      )}
    </>
  );
};
